import Slider from 'react-slick';
import ModalVideo from 'react-modal-video';
import React, { useState } from 'react';

const settings = {
   dots: true,
   infinite: true,
   speed: 500,
   centerMode: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   customPaging: function (i) {
      return (
         <a>
            <img src={`/ReactAssets/CustomerJourney/Home${i + 1}x1.jpg`} />
         </a>
      );
   },
   dotsClass: 'slick-dots slick-thumb',
};
function MobileCarousel() {
   const [isOpen, setOpen] = useState(false);

   return (
      <>
         <div style={{ width: '100vw' }}>
            <Slider {...settings}>
               <div>
                  <img
                     srcset="/ReactAssets/CustomerJourney/Home1x1.jpg 1x, /ReactAssets/CustomerJourney/Home1x2.jpg 2x"
                     src="/ReactAssets/CustomerJourney/Home1x1.jpg"
                     alt="Home 1"
                  />
               </div>
               <div onClick={() => setOpen(true)} className="vid-opener">
                  <img
                     srcset="/ReactAssets/CustomerJourney/Home2x1.jpg 1x, /ReactAssets/CustomerJourney/Home2x2.jpg 2x"
                     src="/ReactAssets/CustomerJourney/Home2x1.jpg"
                     alt="Home 1"
                  />
               </div>
               <div>
                  <img
                     srcset="/ReactAssets/CustomerJourney/Home3x1.jpg 1x, /ReactAssets/CustomerJourney/Home3x2.jpg 2x"
                     src="/ReactAssets/CustomerJourney/Home3x1.jpg"
                     alt="Home 1"
                  />
               </div>
               <div>
                  <img
                     srcset="/ReactAssets/CustomerJourney/Home4x1.jpg 1x, /ReactAssets/CustomerJourney/Home4x2.jpg 2x"
                     src="/ReactAssets/CustomerJourney/Home4x1.jpg"
                     alt="Home 1"
                  />
               </div>
            </Slider>
         </div>
         <ModalVideo
            channel="youtube"
            autoplay
            isOpen={isOpen}
            videoId="ptwNYZIj_QQ"
            onClose={() => setOpen(false)}
            ratio="1:1"
         />
      </>
   );
}

export default MobileCarousel;
